import React, { useState, useEffect, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { check_user_address, post_user_addresses } from "../../redux/actions/location";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocation } from '@fortawesome/free-solid-svg-icons';
import MapSelectLocation from "./mapSelectLocation";


function CreateAddress({ user, post_user_addresses, updateList }) {
    const [open, setOpen] = useState(false);
    const [Longitud, setLongitud] = useState('');
    const [Latitud, setLatitud] = useState('');
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const mapRef = useRef();

    const messages = {
        required: "Este campo es obligatorio",
        minLength: "No puede ingresar menos caracteres de lo establecido",
        maxLength: "No puede ingresar más caracteres en este campo",
        espacioBlanco: 'No esta permitido espacios en blanco',
        aceptaNumeros: 'Solo se acepta números en este campo',
        aceptaLetra: 'Solo se acepta letras en este campo'
    };

    const patterns = {
        espacioBlanco: /^(?!\s)/,
        aceptaNumeros: /^[0-9,-]+$/,
        aceptaLetra: /^[A-Za-z\s]+$/,
    };

    function setLatLng(latlng) {
        setLatitud(latlng.lat);
        setLongitud(latlng.lng);
    }

    const setDireccion = (value) => {
        setValue('Direccion', value);
    }
    const onSubmit = async (formInfo) => {
        reset();
        const data = {
            "user_id": user.id,
            "address": formInfo.address,
            "description": formInfo.description,
            "phone": formInfo.phone,
            "lng": Longitud,
            "lat": Latitud
        };

        await post_user_addresses(data)
        updateList();
        setTimeout(() => {
            setOpen(false);
        }, "1000");
        console.log(data)
    }

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className="bg-ecoprimary1 text-white px-4 py-2 rounded-3 text-sm transition duration-200 me-2 mb-4"
            >
                Crear nueva
            </button>

            <Transition show={open} as={React.Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <div className="fixed inset-0 bg-bgblack bg-opacity-30" />
                    <div className="fixed inset-0 flex items-center justify-center p-4 ">
                        <Dialog.Panel
                            className="w-full max-w-2xl sm:h-[80vh] max-h-[90vh] flex flex-col rounded-lg bg-white shadow-xl transition-all overflow-hidden">

                            <div className="bg-ecoprimary1 text-white py-2 text-center font-semibold text-lg">
                                Crear dirección
                            </div>

                            <div className="flex-1 overflow-y-auto px-4 py-2">
                                <form id="post_location" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                        <div>
                                            <label className="block text-sm font-bold mb-1">Dirección:</label>
                                            <input
                                                className="form-control w-full"
                                                type="text"
                                                placeholder="Dirección"
                                                {...register("address", {
                                                    required: {
                                                        value: true,
                                                        message: messages.required,
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: messages.minLength
                                                    },
                                                    maxLength: {
                                                        value: 100,
                                                        message: messages.maxLength
                                                    },
                                                    pattern: {
                                                        value: patterns.espacioBlanco,
                                                        message: messages.espacioBlanco
                                                    },
                                                }
                                                )}
                                            />
                                            {errors.address && <small
                                                className="text-red-600">{errors.address.message}</small>}
                                        </div>

                                        <div>
                                            <label className="block text-sm font-bold mb-1">Teléfono:</label>
                                            <input
                                                className="form-control w-full"
                                                type="number"
                                                placeholder="59170000000"
                                                {...register("phone", {
                                                    required: {
                                                        value: true,
                                                        message: messages.required,
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: messages.minLength
                                                    },
                                                    maxLength: {
                                                        value: 100,
                                                        message: messages.maxLength
                                                    },
                                                    pattern: {
                                                        value: patterns.espacioBlanco,
                                                        message: messages.espacioBlanco
                                                    },
                                                }
                                                )}
                                            />
                                            {errors.phone &&
                                                <small className="text-red-600">{errors.phone.message}</small>}
                                        </div>

                                        <div className="md:col-span-2 mb-3">
                                            <label className="block text-sm font-bold mb-1">Referencia:</label>
                                            <input
                                                className="form-control w-full"
                                                type="text"
                                                placeholder="Casa portón negro"
                                                {...register("description", {
                                                    required: {
                                                        value: true,
                                                        message: messages.required,
                                                    },
                                                    minLength: {
                                                        value: 3,
                                                        message: messages.minLength
                                                    },
                                                    maxLength: {
                                                        value: 100,
                                                        message: messages.maxLength
                                                    },
                                                    pattern: {
                                                        value: patterns.espacioBlanco,
                                                        message: messages.espacioBlanco
                                                    },
                                                }
                                                )}
                                            />
                                            {errors.description && <small
                                                className="text-red-600">{errors.description.message}</small>}
                                        </div>
                                    </div>
                                    <div className="flex-1 min-h-[200px] h-[30rem]">
                                        <MapSelectLocation ref={mapRef} onlatlng={setLatLng} onClicDireccion={setDireccion}
                                            editable={true} />
                                    </div>
                                </form>
                            </div>

                            {/* Footer con botones */}
                            <div className="border-t-2 px-4 py-3 flex items-center justify-between">
                                <button type="button" className="bg-ecoprimary1 text-white py-2 px-3 rounded text-sm"
                                    onClick={() => mapRef.current?.myLocation()}>
                                    <FontAwesomeIcon icon={faLocation} className="me-2"/> Mi ubicación
                                </button>
                                <div className="flex items-center gap-2">
                                    <button
                                        type="button"
                                        onClick={() => setOpen(false)}
                                        className="bg-blue-100 text-ecoprimary1 py-2 px-3 rounded text-sm"
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="submit" form="post_location"
                                        className="bg-ecoprimary1 text-white py-2 px-3 rounded text-sm"
                                    >
                                        Registrar
                                    </button>
                                </div>
                            </div>



                        </Dialog.Panel>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
}

const mapStateToProps = state => ({
    locations: state.Location.locations,
    location: state.Location.location,
    user: state.Auth.user,
})

export default connect(mapStateToProps, {
    check_user_address, post_user_addresses
})(CreateAddress)
